import baseComponent from 'BASE/components/chat/chat.base.component.roomMessage'

export default {
    mixins: [baseComponent],
};
